import { useNavigate } from "react-router-dom";
import emp1 from "../../../assets/emp1.jpg";
import emp2 from "../../../assets/emp2.jpg";
import emp3 from "../../../assets/emp3.jpg";
import buss1 from "../../../assets/buss1.jpg";
import buss2 from "../../../assets/buss2.jpg";
import buss3 from "../../../assets/buss3.jpg";
interface MainCardsProps {
  onRegisterClick: () => void;
}

const avatars = [emp1, emp2, emp3];

const avatars2 = [buss1, buss2, buss3];

export default function MainCards({ onRegisterClick }: MainCardsProps) {
  const navigate = useNavigate();
  return (
    <section className="py-2" dir="rtl">
      <div className="overflow-x-auto scrollbar-hide">
        <div
          className="flex flex-row gap-3 px-4 pb-1"
          style={{ minWidth: "100%" }}
        >
          {/* Card 1 - Employment */}
          <div
            className="relative rounded-3xl border-[3px] border-gray-900 p-4 overflow-hidden cursor-pointer transition-transform hover:-translate-y-1 flex-1 min-w-[calc(50%-6px)]"
            style={{ background: "#EDE9FE" }}
            onClick={() => navigate("/employment")}
          >
            {/* LIVE tag */}
            <div className="absolute top-3 left-3 flex items-center gap-1 bg-yellow-300 border-2 border-gray-900 rounded-full px-2.5 py-1">
              <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
              <span className="text-xs font-black text-gray-900">LIVE</span>
            </div>

            <div className="flex flex-col gap-3">
              <div>
                <h2 className="text-2xl font-black text-gray-900 leading-tight">
                  ליווי
                  <br />
                  תעסוקתי
                </h2>
                <p className="text-xs font-semibold text-purple-700 mt-1">
                  מעל 2,000 משתתפים פעילים
                </p>
              </div>

              <div className="flex flex-col gap-2 mt-1">
                {/* Avatars */}
                <div className="flex items-center">
                  {avatars.map((src, i) => (
                    <div
                      key={i}
                      className="w-8 h-8 rounded-full border-2 border-white overflow-hidden bg-gray-200"
                      style={{
                        marginLeft: i > 0 ? "-8px" : "0",
                        zIndex: 3 - i,
                      }}
                    >
                      <img
                        src={src}
                        alt="משתתף"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  ))}
                  <span className="mr-2 text-xs font-bold text-purple-800 bg-white border-2 border-purple-300 rounded-full px-2 py-0.5 whitespace-nowrap">
                    +1,997
                  </span>
                </div>

                <button
                  className="flex items-center justify-center gap-1.5 bg-gray-900 text-white rounded-2xl px-3 py-2 text-xs font-bold border-2 border-gray-900 hover:bg-gray-700 transition-colors whitespace-nowrap w-full"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate("/employment");
                  }}
                >
                  פרטים נוספים
                  <i className="ri-arrow-left-line text-sm"></i>
                </button>
              </div>
            </div>

            {/* Decorative circle */}
            <div className="absolute -bottom-8 -left-8 w-32 h-32 rounded-full bg-purple-300 opacity-30"></div>
          </div>

          {/* Card 2 - Business */}
          <div
            className="relative rounded-3xl border-[3px] border-gray-900 p-4 overflow-hidden cursor-pointer transition-transform hover:-translate-y-1 flex-1 min-w-[calc(50%-6px)]"
            style={{ background: "#FEF9C3" }}
            onClick={() => navigate("/business")}
          >
            {/* NEW tag */}
            <div className="absolute top-3 left-3 flex items-center gap-1 bg-purple-400 border-2 border-gray-900 rounded-full px-2.5 py-1">
              <i className="ri-sparkling-fill text-white text-xs"></i>
              <span className="text-xs font-black text-white">חדש</span>
            </div>

            <div className="flex flex-col gap-3">
              <div>
                <h2 className="text-2xl font-black text-gray-900 leading-tight">
                  ליווי
                  <br />
                  עסקי
                </h2>
                <p className="text-xs font-semibold text-yellow-700 mt-1">
                  800+ עסקים קטנים ובינוניים
                </p>
              </div>

              <div className="flex flex-col gap-2 mt-1">
                {/* Avatars */}
                <div className="flex items-center">
                  {avatars2.map((src, i) => (
                    <div
                      key={i}
                      className="w-8 h-8 rounded-full border-2 border-white overflow-hidden bg-gray-200"
                      style={{
                        marginLeft: i > 0 ? "-8px" : "0",
                        zIndex: 3 - i,
                      }}
                    >
                      <img
                        src={src}
                        alt="משתתף"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  ))}
                  <span className="mr-2 text-xs font-bold text-yellow-800 bg-white border-2 border-yellow-300 rounded-full px-2 py-0.5 whitespace-nowrap">
                    +797
                  </span>
                </div>

                <button
                  className="flex items-center justify-center gap-1.5 bg-gray-900 text-white rounded-2xl px-3 py-2 text-xs font-bold border-2 border-gray-900 hover:bg-gray-700 transition-colors whitespace-nowrap w-full"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate("/business");
                  }}
                >
                  פרטים נוספים
                  <i className="ri-arrow-left-line text-sm"></i>
                </button>
              </div>
            </div>

            {/* Decorative circle */}
            <div className="absolute -bottom-8 -left-8 w-32 h-32 rounded-full bg-yellow-300 opacity-30"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
